module.exports = __webpack_public_path__ + "img/秀山重庆秀山大溪国家湿地公园@2x.984c60d7.png";